import { RefundRequestFormValues } from 'features/transaction_list/component/refund-request-filter-form/type';
import { RefundRequestList } from 'features/transaction_list/component/refund-request-table/refund-request-list';
import { RequestRefundTopBar } from 'features/transaction_list/component/top-bar/refund-request-topbar';
import { useGetRefundRequestList } from 'features/transaction_list/use-cases/get-refund-request';
import { useUserContext } from 'features/users';
import { usePaginationParams } from 'hooks';
import { Outlet } from 'react-router-dom';

const getInitialFilterValues: any = {
    UserName: undefined,
    EventName: undefined,
    MobileNumber: undefined,
    Status: undefined,
    FromDate: undefined,
    ToDate: undefined,
};

export const RefundRequestView = () => {
    const { user } = useUserContext();
    const { params, updateParams, resetPage } = usePaginationParams<any>({
        page: 1,
        size: 10,
        RollBy: user?.role,
        ...getInitialFilterValues,
    });
    const { data, refetch, isFetching } = useGetRefundRequestList(params, { retry: false });
    const handleFiltersChange = (values: RefundRequestFormValues) => {
        updateParams(values);
        resetPage();
        refetch()
    };

    return (

        <>
            <RequestRefundTopBar
                handleFilter={handleFiltersChange}
                getInitialFilterValues={getInitialFilterValues}
            // refetch={""}
            />
            <RefundRequestList
                isSocialListLoading={isFetching}
                DeliveryList={data}
                tableParams={params as any}
                updateParams={updateParams}
                refetch={refetch}

            />
            <Outlet />
        </>
    );
};
